import { render, staticRenderFns } from "./detail_form.vue?vue&type=template&id=60f45ddc&scoped=true"
import script from "./detail_form.vue?vue&type=script&lang=js"
export * from "./detail_form.vue?vue&type=script&lang=js"
import style0 from "./detail_form.vue?vue&type=style&index=0&id=60f45ddc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f45ddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f45ddc')) {
      api.createRecord('60f45ddc', component.options)
    } else {
      api.reload('60f45ddc', component.options)
    }
    module.hot.accept("./detail_form.vue?vue&type=template&id=60f45ddc&scoped=true", function () {
      api.rerender('60f45ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/detail/detail_form.vue"
export default component.exports